/**
** 基础数据-检查对象类型
 */
<template>
    <div id="checkObj" class="jc-page">
        <div class="jc-panel jc-page-head">
			<div class="header-title">{{ headerTitle }}</div>
			<div class="header-operation">
				<el-form>                   
                    <el-button class="button" @click="handleDelteMulti">删除</el-button>
                    <el-button class="button" @click="dialogVisible = true">添加</el-button>
                </el-form>
			</div>
		</div>
        <div class="jc-table-container jc-scroll-panel">
            <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="55"></el-table-column>
                    <!-- <el-table-column type="index" label="序号" width="55"></el-table-column> -->
                    <el-table-column label="检查对象类型">
                        <template slot-scope="scope">{{scope.row.checkup_object_type_name}}</template>
                    </el-table-column>
                    <!-- <el-table-column label="登录用户名">
                        <template slot-scope="scope">{{scope.row.userName}}</template>
                    </el-table-column>
                    <el-table-column label="手机号">
                        <template slot-scope="scope">{{scope.row.telephone}}</template>
                    </el-table-column>
                    <el-table-column label="是否是超级管理员"  show-overflow-tooltip>
                        <template slot-scope="scope">{{scope.row.role}}</template>
                    </el-table-column> -->
                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click="handleEdit(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
                            <span>|</span>
                            <el-button type="text" size="small" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                    <el-pagination
                    background
                    style="text-align:right"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-size="count"
                    layout="total, prev, pager, next"
                    :total="total"
                    >
                </el-pagination>
        </div>
        
		<el-dialog title="添加检查对象类型" :visible.sync="dialogVisible" class="dialog">
            <el-form ref="checkObjForm" :model="checkObjForm">
                <!-- <el-row>
                    <el-col :span="12"> -->
                        <el-form-item label="检查对象类型">
                            <el-input v-model="checkObjForm.type" placeholder="请输入检查对象类型"></el-input>
                        </el-form-item>
                    <!-- </el-col>
                </el-row> --> 
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submit()">确定</el-button>
            </div>
        </el-dialog>

        <!-- 详情对话框dialog -->
        <el-dialog title="检查对象类型详情" :visible.sync="DetailDialogVisible" class="dialog">
            <el-form ref="detailForm" :model="detailForm">
                <!-- <el-row>
                    <el-col :span="12"> -->
                        <el-form-item label="检查对象类型">
                            <el-input v-model="detailForm.type" placeholder="请输入检查对象类型"></el-input>
                        </el-form-item>
                    <!-- </el-col>
                </el-row> --> 
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="DetailDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitDetail()">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {deleteCheckupObjectTypeInfo, getCheckupObjectTypeDetail, saveCheckupObjectTypeInfo, getCheckupObjectTypeList} from '@/apis/checkObj'
export default {
    name:"CheckObj",
    data(){
        return {
            headerTitle:"检查对象类型",
            dialogVisible:false,//对话框显示标识
            DetailDialogVisible:false,//详情对话框显示标识
            multipleSelection:[],//表格
            tableData:[
                // {
                //     checkup_object_type_name:"老旧小区"
                // },
                // {
                //     checkup_object_type_name:"乡村"
                // }
            ],//表格内容
            checkObjForm:{
                type:""
            }, // 添加检查对象类型对话框-表单
            detailForm:{
                type:""
            },// 检查对象类型详情对话框-表单
            currentPage:1,// 当前页数
            count:10,//表格页数
            total:0,// 总条目数
            recordId:''
        }
    },
    created(){
        //14-检查对象分类-获得检查对象分类列表
        this.getCheckObjList();
    },
    methods:{
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
                this.getCheckObjList();
            },
			// 表格多选
			handleSelectionChange(val){
                this.multipleSelection = [];
                //organization_id
                val.forEach(item => {
                this.multipleSelection.push(parseInt(item.checkup_object_type_id));
                })
                console.log('批量选择',this.multipleSelection);

            },
            // 批量删除--点击头部“删除”按钮
            handleDelteMulti(){
                this.$confirm('是否确定删除数据？', "提示").then(()=>{
                    deleteCheckupObjectTypeInfo({checkup_object_type_id_list:this.multipleSelection}).then(res => {
                    console.log('批量删除',res);
                    if(res.data.status == "1"){
                        this.$message({
                            message: '删除成功！',
                            type: 'success'
                        });
                        this.getCheckObjList();
                    }else{
                        this.$message.error('删除失败！');
                    }
                })
                })
                
            },
			// 表格中点击"删除"--17-检查对象分类-删除检查对象分类信息
			handleDelete(index,row){
				console.log('删除',index,row);
                this.$confirm('是否确定删除数据？', "提示").then(()=>{
                    deleteCheckupObjectTypeInfo({checkup_object_type_id_list:[row.checkup_object_type_id]}).then(res => {
                    console.log('单个删除',res);
                    if(res.data.status == "1"){
                        this.$message({
                        message: '删除成功！',
                        type: 'success'
                    });
                    this.getCheckObjList()
                    }else {
                        this.$message.error('删除失败！');
                    }
                })
                })
                
			},
			// 点击表格中"编辑"
            // 15-检查对象分类-获得检查对象分类详情
			handleEdit(index,row){
				console.log('编辑',index,row);
                this.recordId = row.checkup_object_type_id
                this.DetailDialogVisible = true;
                getCheckupObjectTypeDetail({
                        checkup_object_type_id:row.checkup_object_type_id
                    }).then(res => {
                    console.log('检查对象详情',res);
                    if(res.data.status == "1"){
                        this.detailForm.type = res.data.data.checkup_object_type_info.checkup_object_type_name;
                    }
                })
			},
            // 点击详情dialog对话框中“确定”按钮，保存信息
            submitDetail(){
                let obj = {
                    checkup_object_type_id:this.recordId,
                    checkup_object_type_name:this.detailForm.type
                };
                saveCheckupObjectTypeInfo(obj).then(res => {
                    console.log('添加检查对象',res);
                    if(res.data.status == "1" ){
                        this.$message({
                            message: '保存成功！',
                            type: 'success'
                        });
                        this.DetailDialogVisible = false;
                        this.getCheckObjList();
                    }else {
                        this.$message.error(`${res.data.msg}`);
                    }
                })
            },
			// 点击添加对话框中"确定"按钮
            // 16-检查对象分类-保存检查对象分类信息
			submit(){
                let obj = {
                    checkup_object_type_id:0,
                    checkup_object_type_name:this.checkObjForm.type
                };
                saveCheckupObjectTypeInfo(obj).then(res => {
                    console.log('添加检查对象',res);
                    if(res.data.status == "1" ){
                        this.$message({
                            message: '保存成功！',
                            type: 'success'
                        });
                        this.dialogVisible = false;
                        this.getCheckObjList();
                        this.checkObjForm = {
                            type:''
                        }
                    }else {
                        this.$message.error(`${res.data.msg}`);
                    }
                })
            },
            // 14-检查对象分类-获得检查对象分类列表
            getCheckObjList(){
                let obj = {
                    pagination:{
                        page:this.currentPage,
                        count:this.count
                    }
                };
                getCheckupObjectTypeList(obj).then(res => {
                    console.log('检查对象分类列表',res);
                    if(res.status == 200 || res.data.status == "1"){
                        this.tableData = res.data.data.checkup_object_type_list;
                        this.count = parseInt(res.data.data.paginated.count);
                        this.total = parseInt(res.data.data.paginated.total);
                        this.$message({
                            message: '获取成功！',
                            type: 'success'
                        }); 
                    }else {
                        this.$message.error(`${res.data.msg}`);
                    }
                    
                })
            }
    }
}
</script>
<style scoped>
#checkObj{
    position: relative;
}
.header {
    width: 100%;
    height: 35px !important;
    border-bottom: 1px solid #ccc;
}
.header-left {
    width: 200px;
    text-align: left;
    position: absolute;
}
.header-title {
    font-weight: bold;
}
.header-right {
    position: absolute;
    right: 20px;
    /* width: 15%; */
    height: 35px;
    top: -15px;
}
.el-form{
    display: flex;
    height: 35px;
}
.el-form-item {
    width: 180px;
    margin-right: 10px;
}
.button {
    height: 38px;
    color: #fff;
    background-color: #000;
}
#checkObj >>> .el-input__inner {
    height: 35px;
    padding: 0 10px;
    border: 1px solid #000;
}
#checkObj >>> .el-input input::-webkit-input-placeholder{
    color: #9e9fa3;
}
/* 表格样式修改 */
.el-table{
    color: #000;
}
#checkObj >>> .el-table thead{
    color:#000;
    font-weight: unset;
}
#checkObj >>> .el-table__header{
    width: 100%;
   
}
#checkObj >>> .el-table th.el-table__cell{
    background-color: #f3f3f3;
}
/* #organlist >>> .el-table tr{
    
} */
#checkObj >>> .el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: unset;
}
.el-button--text{
    color: #000;
    font-size: 13px;
}
.el-table__row>td{
    border: none;
}
.el-table::before{
    height: 0px;
}
#checkObj >>> .el-checkbox__inner{
    width: 16px;
    height: 16px;
    border: 1px solid #9e9fa3;
}
/* 对话框样式修改 */
#checkObj >>> .dialog .el-dialog{
	width: 40%;
}
#checkObj >>> .dialog .el-dialog__header{
    text-align: left;
}
#checkObj >>> .dialog .el-dialog__title{
    font-size: 20px; 
}
#checkObj >>> .dialog .el-dialog__body{
    padding: 10px 20px;
    color: #000;
}
#checkObj >>> .dialog .el-dialog__body .el-form{
    width: 100%;
    height: 100%;
    display: block;
}
#checkObj >>> .dialog .el-dialog__body .el-form-item {
    width: 85%;
    margin-bottom: 15px;
}
#checkObj >>> .dialog .el-form-item__label{
    color: #000;
    font-size: 16px;
    text-align: left;
    line-height: 35px;
}
#checkObj >>> .dialog .el-input__inner {
    border: 1px solid #409eff;
    color: #000;
}
#checkObj >>> .dialog .el-select {
    width: 100%;
}
#checkObj >>> .dialog .el-dialog__footer {
    padding: 0px 20px 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/backStage/children/CheckObj/CheckObj.vue